import { LoadingSpinner } from "components/LoadingSpinner";
import useDocumentTitle from "hooks/useDocumentTitle";
import { useEffect } from "react";
import { useForm, FormProvider } from "react-hook-form";
import { useParams, useSearchParams } from "react-router-dom";
import { useGetDiscountRulesetByIdQuery } from "store/queries/procedureDiscountRuleset";

import { AllowDuplicateCptCodes } from "./components/AllowDuplicateCptCodes";
import { CptCodes } from "./components/CptCodes";
import { DiscountPercents } from "./components/DiscountPercents";
import { Header } from "./components/Header";
import { ProviderAndPayerCopySection } from "./components/ProviderAndPayerCopySection";
import { RuleName } from "./components/RuleName";
import { Submit } from "./components/Submit";

export function CopyPayerRulesPage() {
  useDocumentTitle("Copy Payer Rules");
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const asDefault = searchParams.get("asDefault") === "true";
  const { data: ruleset, isLoading } = useGetDiscountRulesetByIdQuery(id);

  const methods = useForm({
    defaultValues: {
      provider: asDefault
        ? []
        : [
            {
              name: ruleset?.data.provider?.name,
              value: ruleset?.data.provider?.id,
            },
          ],
      payerName: asDefault
        ? []
        : [
            {
              name: ruleset?.data?.payer?.name,
              value: ruleset?.data?.payer?.id,
            },
          ],
      groupName: ruleset?.data.groupName,
      cptCodes: ruleset?.data.cptCodes,
      discountPercentForRank2: ruleset?.data.discountPercentForRank2,
      discountPercentForRank3: ruleset?.data.discountPercentForRank3,
      discountPercentForRank4: ruleset?.data.discountPercentForRank4,
      discountPercentForRank5Plus: ruleset?.data.discountPercentForRank5Plus,
      allowOnDuplicateCptCodes: ruleset?.data.allowOnDuplicateCptCodes,
      isDefault: asDefault,
    },
  });

  useEffect(() => {
    if (ruleset) {
      methods.reset({
        provider: asDefault
          ? []
          : [
              {
                name: ruleset?.data.provider?.name,
                value: ruleset?.data.provider?.id,
              },
            ],
        payerName: asDefault
          ? []
          : [
              {
                name: ruleset?.data?.payer?.name,
                value: ruleset?.data?.payer?.id,
              },
            ],
        groupName: ruleset?.data.groupName,
        cptCodes: ruleset?.data.cptCodes,
        discountPercentForRank2: ruleset?.data.discountPercentForRank2,
        discountPercentForRank3: ruleset?.data.discountPercentForRank3,
        discountPercentForRank4: ruleset?.data.discountPercentForRank4,
        discountPercentForRank5Plus: ruleset?.data.discountPercentForRank5Plus,
        allowOnDuplicateCptCodes: ruleset?.data.allowOnDuplicateCptCodes,
        isDefault: asDefault,
      });
    }
  }, [ruleset, methods, asDefault]);

  if (isLoading) {
    return <LoadingSpinner />;
  }
  return (
    <FormProvider {...methods}>
      <Header name={ruleset?.data.groupName} />
      <ProviderAndPayerCopySection
        initialProviders={[
          {
            name: ruleset?.data.provider?.name || "",
            value: ruleset?.data.provider?.id || "",
          },
        ]}
        initialPayers={[
          {
            name: ruleset?.data?.payer?.name || "",
            value: ruleset?.data?.payer?.id || "",
          },
        ]}
      />
      <RuleName />
      <AllowDuplicateCptCodes />
      <CptCodes />
      <DiscountPercents />
      {id && ruleset && <Submit />}
    </FormProvider>
  );
}
